import { render } from "./TradeEconomicRelRussia.vue?vue&type=template&id=271a033e"
import script from "./TradeEconomicRelRussia.vue?vue&type=script&lang=js"
export * from "./TradeEconomicRelRussia.vue?vue&type=script&lang=js"

import "./TradeEconomicRelRussia.vue?vue&type=style&index=0&id=271a033e&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__